import { useMemo, useState } from 'react';
import { useTranslation } from '../../../../lib/i18n';
import { draftHeadline, draftReviewHtml, type DraftPreviewCardData } from '../../../../lib/draft-preview';
import { prefetchDraftReview, useDraftInlinePreview } from '../../../../lib/draft-preview-api';
import { inlinePreviewDocument } from '../../../../lib/email-review';
import { useIsPhone } from '../../../../lib/use-is-phone';
import { InlineHtmlPreview } from './InlineHtmlPreview';

const EMAIL_WIDTH = 700;
const PHONE_WIDTH = 375;

export function DraftInlinePreview({ card, cardKey }: { card: DraftPreviewCardData; cardKey: string }) {
  const { t } = useTranslation();
  const [seen, setSeen] = useState(false);
  const phone = useIsPhone();
  const email = card.kind === 'EMAIL';
  const ids = { workspaceId: card.workspaceId, taskId: card.taskId, draftId: card.draftId, kind: card.kind };
  const preview = useDraftInlinePreview(ids, cardKey, seen);
  const html = useMemo(() => (preview.data ? inlinePreviewDocument(draftReviewHtml(card, preview.data)) : undefined), [card, preview.data]);
  const copy = email ? 'emailReview' : 'blogDraft';
  return (
    <InlineHtmlPreview
      html={html}
      title={draftHeadline(card, preview.data) || t(`${copy}.card.title`)}
      naturalWidth={email && !phone ? EMAIL_WIDTH : PHONE_WIDTH}
      status={t(preview.isError ? `${copy}.unavailable` : `${copy}.loading`)}
      failed={preview.isError}
      onSeen={() => {
        setSeen(true);
        prefetchDraftReview(ids, cardKey);
      }}
      testId="draftInlinePreview"
    />
  );
}
